export const ActionTypes = {
  LOAD_STYLES: 'STYLES/LOAD',
  STYLES_REQUESTED: 'STYLES/REQUESTED',
  STYLES_FETCH_SUCCEEDED: 'STYLES/FETCH_SUCCEEDED',
  STYLES_FETCH_FAILED: 'STYLES/FETCH_FAILED',
  STYLES_UPDATED: 'STYLES/UPDATED',
} as const
